import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const MAX_VISIBLE_PAGES = 5;

const GroupTablePaginate = ({
    pages,
    page,
    canPrevious,
    canNext,
    onPageChange,
}) => {
    const visiblePages = [];

    const startPage = Math.floor(page / MAX_VISIBLE_PAGES) * MAX_VISIBLE_PAGES;
    const endPage = Math.min(startPage + MAX_VISIBLE_PAGES, pages);

    for (let i = startPage; i < endPage; i++) {
        visiblePages.push(i);
    }

    const goToPage = (p) => {
        if (p >= 0 && p < pages) {
            onPageChange(p);
        }
    };

    return (
        <Pagination className="item-center mt-3">
            {/* Previous Button */}
            <PaginationItem disabled={!canPrevious}>
                <PaginationLink
                    onClick={() => goToPage(page - 1)}
                >  <i className="simple-icon-arrow-left" />
                </PaginationLink>
            </PaginationItem>

            {/* Page Numbers */}
            {visiblePages.map((p) => (
                <PaginationItem key={p} active={p === page}>
                    <PaginationLink onClick={() => goToPage(p)}>
                        {p + 1}
                    </PaginationLink>
                </PaginationItem>
            ))}

            {/* Next Button */}
            <PaginationItem disabled={!canNext}>
                <PaginationLink
                    onClick={() => goToPage(page + 1)}
                > <i className="simple-icon-arrow-right" />
                </PaginationLink>
            </PaginationItem>
        </Pagination>
    );
};

export default GroupTablePaginate;
